module.exports = __webpack_public_path__ + "202408221624/img/icon_psd_18_20@2x.bfb862b8.png";